export const resolveThemeFromPaths = (oldPath, newPath, props, FLOW_THEMES = {}) => {
  const regExp = new RegExp(`${props.basePath}\\/?`);

  const oldConfigPath = oldPath.replace(regExp, '');
  const newConfigPath = newPath.replace(regExp, '');

  const from =
    (typeof FLOW_THEMES[oldConfigPath] === 'function'
      ? FLOW_THEMES[oldConfigPath](props)
      : FLOW_THEMES[oldConfigPath]) || 'noop';
  const to =
    (typeof FLOW_THEMES[newConfigPath] === 'function'
      ? FLOW_THEMES[newConfigPath](props)
      : FLOW_THEMES[newConfigPath]) || 'noop';

  return { from, to };
};
